import { DocumentError } from '@/gen/artifacts/v1/model_pb'

import { DocumentStatus } from '@/const/artifact-status.types'

export const TIMELINE_STATUSES: DocumentStatus[] = [
  DocumentStatus.PENDING,
  DocumentStatus.CLASSIFYING,
  DocumentStatus.COMPLETE,
]

export const ERRORS_WITH_CONTACT_LINK: DocumentError[] = [
  DocumentError.UNKNOWN_CATEGORY,
  DocumentError.NO_TEXT_EXTRACTED,
  DocumentError.UNKNOWN_ERROR,
]
